module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zo1l0y/tc-custom/9781685500009.jpg?1723405091415",
      "alt": "This image is the cover for the book Rogue Delivery"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rogue Delivery\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lyndon is running on empty when he makes his last courier pickup of the day at a strange business. He’s definitely not ready for the shy and attractive man who’s supposed to sign off on the delivery to jump into his van and order him to drive as fast as he can. But acting on instinct is sort of Lyndon’s thing, so before he knows it he’s in a cross-country chase with danger hot on his heels."), _c('br'), _c('br'), _vm._v("Curtis had his doubts about working for his employers, but he deeply appreciated the routine of it. When he discovers that he might have unwittingly helped create a bug that could spread like a deadly fire through the country, though, he knows he has to act, and he’s only glad that the brash courier who picks him up is willing to go all the way to make sure what Curtis is carrying reaches its final destination.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gareth Vaughn\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0